module.exports = __webpack_public_path__ + "img/kkb_vertical_fog.27d7fef5.jpg";